import { tabStorage } from './tabStorage';
import { clearCachedFileUrls } from '../hooks/useCachedFileUrl';

const clearFrappeCookies = () => {
  ['sid', 'system_user', 'full_name', 'user_id', 'user_image'].forEach((name) => {
    try {
      document.cookie = `${name}=; Max-Age=0; path=/`;
    } catch (_) {
      // ignore cookie cleanup errors
    }
  });
};

export const performForceLogout = (redirectPath = '/login') => {
  clearCachedFileUrls();

  try {
    tabStorage.clearAccountKeys();
  } catch (_) {}

  try {
    localStorage.clear();
  } catch (_) {}

  try {
    sessionStorage.clear();
  } catch (_) {}

  clearFrappeCookies();

  try {
    window.location.replace(redirectPath);
  } catch (_) {
    window.location.href = redirectPath;
  }
};
